import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import { libraryShape, subscriptionShape } from '@bibliocommons/bc-prop-types';

import { trackRequestExternalPlace } from 'app/actions/AnalyticsGa4Actions';
import BibsActions from 'app/actions/BibsActions';
import useStackMap from 'app/hooks/useStackMap';
import {
  selectAvailabilityError,
  selectBibItemsForCurrentBib,
  selectProbesForCurrentBib,
  selectSubscriptionsForCurrentBib
} from 'app/selectors/bibs/AvailabilitySelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import bibItemShape from 'app/shapes/bibItemShape';
import AvailabilityDetails from './AvailabilityDetails';

export function AvailabilityDetailsContainer(props) {
  const { fetchAvailability, metadataId } = props;

  const { fetchMap: fetchStackMap, state: stackMapState } = useStackMap();

  useEffect(() => {
    fetchAvailability(metadataId);
  }, [fetchAvailability, metadataId]);

  return <AvailabilityDetails {...props} fetchStackMap={fetchStackMap} stackMapState={stackMapState} />;
}

AvailabilityDetailsContainer.propTypes = {
  availabilityError: PropTypes.string,
  bibItems: ImmutablePropTypes.listOf(bibItemShape).isRequired,
  currentLibrary: libraryShape.isRequired,
  fetchAvailability: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  metadataId: PropTypes.string.isRequired,
  probes: ImmutablePropTypes.list.isRequired,
  subscriptions: ImmutablePropTypes.listOf(subscriptionShape).isRequired
};

const mapStateToProps = state => ({
  availabilityError: selectAvailabilityError(state),
  currentView: state.getIn(['search', 'catalogSearch', 'view']),
  currentLibrary: selectCurrentLibrary(state),
  bibItems: selectBibItemsForCurrentBib(state),
  isFetching: state.getIn(['bibs', 'availability', 'isFetching'], false),
  pagination: state.getIn(['search', 'catalogSearch', 'pagination']),
  probes: selectProbesForCurrentBib(state),
  sortBys: state.getIn(['search', 'catalogSearch', 'sortBys']),
  subscriptions: selectSubscriptionsForCurrentBib(state)
});

const mapDispatchToProps = {
  fetchAvailability: BibsActions.fetchAvailability,
  trackRequestExternalPlace
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityDetailsContainer);
